import { render, staticRenderFns } from "./ManageSamples.vue?vue&type=template&id=a6e5be22&"
import script from "./ManageSamples.vue?vue&type=script&lang=ts&"
export * from "./ManageSamples.vue?vue&type=script&lang=ts&"
import style0 from "./ManageSamples.vue?vue&type=style&index=0&id=a6e5be22&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports